import CalloutRepository from "../CalloutRepository"

export default class FeatureCallout2 extends CalloutRepository {
    static schemaId = "feature_callout2"

    constructor() {
        super(FeatureCallout2.schemaId)
    }
}
